// extracted by mini-css-extract-plugin
export default {"button":"StO8i","buttonContainer":"kJtIY","text":"rD3dz","plus":"iYHP+","disabled":"vscrI"};